export const CONTENT_WIDTH = 847;
export const MOBILE_CONTENT_WIDTH = '85%';
